import { Chart, ChartItem } from "chart.js";
import { legendConfig, onResize } from "./chartJsPlugins";
import { getContrastColor, htmlLegendPlugin } from "./configs";


// @ts-ignore
window.initTeacherPositionBlock = function ($, blockId, config, data) {
    //console.log('config', config);
    //console.log('data', data);

    let teacherChart;
    type FormattedRow = {
        year: string;
        values: {
            label: string;
            value: number;
        }[]
    };
    

    const columnLabels = ["TeacherPositionTotal", "TeacherStaffedPosition", "TeacherVacantPosition"]; // ordered how they appear on the chart
    // EVERY array in this formatted data should be sorted _somehow_ for consistency. Some of the chart code depends on it
    // using an array for values instead of a keyed object to ensure order is preserved. maybe brainstorm for a cleaner answer?
    // an alternative would be always using labels to find the index it should be
    console.log('')
    let teacherFormattedData: FormattedRow[];
    let teacherLabels
 
  

    const getColumnValue = (entry, property) => {
        return entry.values.find(v => v.label == property).value;
    };

    const tooltipConfig = {
        enabled: true,
        callbacks: {
            title: function (tooltipItem) {
                return ''
            },
            label: function (tooltipItem) {
                let line1 = [`${tooltipItem.dataset.label}: ${tooltipItem.formattedValue}`];
                let line2 = `School Year: ${tooltipItem.label}`;
                line1.push(line2);
                return line1;
            }
        }
    };

    const topLabels = {
        id: 'topLabels',
        afterDatasetsDraw(chart, args, options) {
            const { ctx, scales: { x } } = chart;
            let display = true;
            // Read from the `chart` argument rather than the `teacherChart` variable, which
            // is not assigned yet the first time this plugin runs.
            let isWide = chart.width > 505;
            ctx.save();
            if (isWide) {
                ctx.font = "500 14px \"Roboto\", Roboto, Arial, sans-serif";
            } else {
                ctx.font = "500 10px \"Roboto\", Roboto, Arial, sans-serif";
            }
            chart.data.datasets.forEach((dataset, index) => {
                if (!chart.isDatasetVisible(index)) {
                    display = false
                }
            })

            // Per-segment counts drawn inside each bar. chartjs-plugin-datalabels resolves a
            // different copy of Chart.js than this file does (ESM vs CJS build), so its
            // `el instanceof BarElement` check fails and it positions these labels with its
            // fallback positioner - which puts them on the bar's right edge. Draw them here.
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            chart.data.datasets.forEach((dataset, index) => {
                if (!chart.isDatasetVisible(index)) return;
                chart.getDatasetMeta(index).data.forEach((segment: any, i) => {
                    const value = dataset.data[i];
                    if (!value) return;
                    // skip segments too short to hold their label
                    if (Math.abs(segment.y - segment.base) < 16) return;
                    ctx.fillStyle = getContrastColor((dataset.backgroundColor as string) ?? '#ffffff');
                    ctx.fillText(String(value), segment.x, (segment.y + segment.base) / 2);
                });
            });

            if (display) {
                // Chart.js v4 no longer leaves the canvas baseline at a predictable value,
                // so set it explicitly or the totals render over the top of the bars.
                ctx.textAlign = 'center';
                ctx.textBaseline = 'bottom';
                ctx.fillStyle = '#000000';
                chart.data.datasets[0].data.forEach((datapoint, index) => {
                    let sum = getColumnValue(teacherFormattedData[index], 'TeacherPositionTotal');
                    const topSegment = chart.getDatasetMeta(1).data[index] as any;
                    if (!topSegment) return;
                    ctx.fillText(sum, x.getPixelForValue(index), topSegment.y - 10);
                });
            }
            ctx.restore();
        }
    }

    const legendPad = {
        beforeInit(chart) {
            const originalFit = chart.legend.fit;
            chart.legend.fit = function fit() {
                originalFit.bind(chart.legend)();
                this.height += 15;
            }
        }
    }


    function getDataForLabel(label) {
        return teacherFormattedData.map(col => getColumnValue(col, label));
    }

    function getTeacherData() {
        return {
            labels: teacherLabels,
            datasets: [
                {
                    label: 'Staffed Teacher Positions',
                    data: getDataForLabel('TeacherStaffedPosition'),
                    backgroundColor: '#061A53',
                },
                {
                    label: 'Vacant Teacher Positions',
                    data: getDataForLabel('TeacherVacantPosition'),
                    backgroundColor: '#F75C03',
                }
            ]
        };
    }

    function getTeachersConfig() {
        const data = getTeacherData();
        // just in case the metric data is malformed or missing
        let max = null;
        try {
            max = 0;
            const count = data.datasets[0].data.length;
            for (let i = 0; i < count; i++) {
                max = Math.max(max, data.datasets[0].data[i] + data.datasets[1].data[i]);
            }
        } catch (e) {}
        
        let config = {
            type: 'bar',
            plugins: [topLabels, legendPad,  htmlLegendPlugin],
            data: getTeacherData(),
            options: {

                onResize: onResize,
                // room for the totals drawn above the tallest bar
                layout: {
                    padding: {
                        top: 24
                    }
                },
                scales: {
                    x: {
                        stacked: true,
                        grid: {
                            display: true,
                            color: '#DDE0E7'
                        },
                        border: {
                            dash: [5, 5]
                        },
                    },
                    y: {
                        ...(max ? { max: max + 8 } : {}),
                        grid: {
                            display: false,
                        },

                        stacked: true,
                        title: {
                            display: true,
                            text: "# of Positions"
                        }
                    }
                },
                plugins: {
                    // chartjs-plugin-datalabels is registered globally in
                    // studentRacialMakeup-block.ts, so dropping it from this chart's `plugins`
                    // array is not enough - it has to be switched off explicitly. This chart
                    // draws its own labels in the topLabels plugin above.
                    datalabels: { display: false },
                    legend: { display: false },
                    tooltip: tooltipConfig,
                    htmlLegend: {
                        containerID: `${blockId}-teacher-position-additional-block`
                    }
                }
            }
        };
        return config;
    }

    function createTeacherTable() {
        const teacherChartBox = document.getElementById('teacher-table');
        const teacherTableDiv = document.createElement('div');
        const table = document.createElement('table');
        table.classList.add('chart-table');

        // **** Header
        const thead = table.createTHead();
        thead.insertRow(0);

        for (let i = 0; i < teacherLabels.length; i++) {
            thead.rows[0].insertCell(i).outerHTML = "<th>" + teacherLabels[i] + "</th>";
        }

        thead.rows[0].insertCell(0).classList.add('light-cyan');
        const tbody = table.createTBody();

        // **** Body
        teacherChart.data.datasets.slice(0).map((dataset, index) => {
            tbody.insertRow(index);

            for (let i = 0; i < teacherChart.data.datasets[0].data.length; i++) {
                tbody.rows[index].insertCell(i).innerText = teacherChart.data.datasets[index].data[i];
            }

            tbody.rows[index].insertCell(0).outerHTML = "<th scope='row'>" + dataset.label + "</th>";
        })
        tbody.insertRow(2);

        // **** Total row needs to be looked up from the parent dataset
        teacherFormattedData.forEach((item, i) => {
            // @ts-ignore
            tbody.rows[2].insertCell(i).innerText = getColumnValue(item, 'TeacherPositionTotal');
        })
        tbody.rows[2].insertCell(0).outerHTML = "<th scope='row'>Total Teachers Positions</th>";

        //append
        teacherChartBox.appendChild(teacherTableDiv);
        teacherTableDiv.appendChild(table);

    }

    if (data) {
        teacherFormattedData = data.map(entry => ({
            year: entry.SchoolYear,
            values: columnLabels.map(label => ({
                label: label,
                value: entry[label] ? parseInt(entry[label]) : 0 // defaulting to zero here, but I think we need to account for the "no data" conditions
            })).sort((a, b) => columnLabels.indexOf(b.label) - columnLabels.indexOf(a.label))
        })).sort((a, b) => a.year.localeCompare(b.year)); // probably do a smarter compare for years

        teacherLabels = teacherFormattedData.map(row => row.year);
        teacherChart = new Chart(
            document.getElementById('teachers') as ChartItem,
            // @ts-ignore
            getTeachersConfig()
        );
        createTeacherTable()
    }
    

};